module.exports = __webpack_public_path__ + "img/t-shirt-black.73ed5b2d.svg";